module.exports = __webpack_public_path__ + "img/honor_5.f95f5b8a.png";